import { deleteColumnOptionState, deleteColumnTemplate, getColumnOptionState, removeComponentPropsPatcherAddSelectedGroupByColumns, removeDatapointRequest, updateEditorPreviewWidgetComponentProps, updateOrAddColumnOptionState, updateOrAddColumnTemplate } from "../helpers";
import { ColumnOptionType } from "../types";
const removeGroupingOptionsDatapoints = (groupingOptionsDatapoints, columnOptionStateId) => {
    const index = groupingOptionsDatapoints.findIndex((go) => go.id === columnOptionStateId);
    if (index !== -1) {
        groupingOptionsDatapoints.splice(index, 1);
    }
};
const removeGroupingOnlyColumn = (state, columnOptionStateId) => {
    deleteColumnOptionState(state, columnOptionStateId);
    deleteColumnTemplate(state, columnOptionStateId);
    updateEditorPreviewWidgetComponentProps(state);
    removeDatapointRequest(state, columnOptionStateId);
};
export const removeSettingsGroupingOptionsDatapointsReducer = (state, action) => {
    if (!state.editor?.settings?.groupingOptionsDatapoints || !action.payload) {
        return;
    }
    const { groupingOptionsDatapoints } = state.editor.settings;
    const columnOptionStateId = action.payload.id;
    removeGroupingOptionsDatapoints(groupingOptionsDatapoints, columnOptionStateId);
    removeComponentPropsPatcherAddSelectedGroupByColumns(state);
    const column = getColumnOptionState(state, columnOptionStateId);
    if (column) {
        if (column?.enableRowGroup) {
            removeGroupingOnlyColumn(state, columnOptionStateId);
        }
        else {
            const newColumn = { ...column, columnOptionType: ColumnOptionType.Column, enableRowGroup: false, hide: false, rowGroup: undefined, rowGroupIndex: undefined };
            updateOrAddColumnOptionState(state, newColumn);
            updateOrAddColumnTemplate(state, newColumn);
        }
    }
};
